import React from 'react';
import { galleryImages } from '../data/mockData';

export const GallerySection = () => {
  return (
    <section id="gallery" className="py-24 bg-[#1A1A1A]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2
            className="text-5xl md:text-6xl font-bold text-[#3ABEFF] mb-4"
            style={{ fontFamily: "'Crimson Text', serif" }}
          >
            Notre Galerie
          </h2>
          <p 
            className="text-lg text-gray-400 max-w-2xl mx-auto"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            Découvrez nos délicieuses créations culinaires
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {galleryImages.map((image) => (
            <div
              key={image.id}
              className="group relative overflow-hidden rounded-lg shadow-xl aspect-square cursor-pointer transition-all duration-300 hover:transform hover:scale-105"
            >
              <img
                src={image.url}
                alt={image.alt}
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
